import * as z from "zod/v4";

export const pickWorkOrderLine = {
  name: "pickWorkOrderLine" as const,
  input: z.object({
    pickLineId: z.string(),
    quantityPicked: z.number().int().nonnegative(),
  }),
  output: z.object({ success: z.boolean() }),
};
